import React from 'react';
import { Banner } from './banner';
import { Container, PageBreadcrumbs, SEOText } from '../../common/components';
import {
	blackBgWrapper,
	containerFullWidthStyles,
	containerWithMarginBottomStyles,
	containerWithMarginTopStyles,
	yellowBrWrapper,
	greyBgWrapper,
	containerMobileDark,
	breadCrumbsStyles,
	wrapperStyles,
} from './styles';
import { CTABlock } from './cta-block';
import { Benefits } from './benefits';
import { Credit } from './credit';
import { Cost } from './cost';
import { Steps } from './steps';
import { ApplicationForm } from './application-form';
import { OtherServices } from './other-services';
import { QuestionsAccordion } from './questions-accordion';

export const RoughWork = () => (
	<section className={wrapperStyles}>
		<Container>
			<PageBreadcrumbs wrapperClassName={breadCrumbsStyles} />
		</Container>
		<div className={yellowBrWrapper}>
			<Container className={containerFullWidthStyles}>
				<Banner />
			</Container>
		</div>
		<div className={blackBgWrapper}>
			<Container className={containerFullWidthStyles}>
				<CTABlock />
			</Container>
		</div>

		<Container className={containerWithMarginTopStyles}>
			<Benefits />
		</Container>
		<Container className={containerWithMarginTopStyles}>
			<Credit />
		</Container>
		<Container className={containerWithMarginTopStyles}>
			<Cost />
		</Container>
		<Container className={containerWithMarginTopStyles}>
			<Steps />
		</Container>
		<Container className={`${containerWithMarginTopStyles} ${containerMobileDark}`}>
			<ApplicationForm />
		</Container>
		<Container className={`${containerWithMarginTopStyles} ${containerWithMarginBottomStyles}`}>
			<QuestionsAccordion />
		</Container>
		<div className={greyBgWrapper}>
			<Container className={containerFullWidthStyles}>
				<OtherServices />
			</Container>
		</div>
		<SEOText />
	</section>
);
